import React from 'react'
import { Action } from 'redux'

export default function(ref: React.RefObject<HTMLDivElement>): ISetDrawerRef {
  return {
    ref,
    type: 'Set drawer ref',
  }
}

export interface ISetDrawerRef extends Action<'Set drawer ref'> {
  ref?: React.RefObject<HTMLDivElement>
}
